import { merge } from 'lodash';
import { MODES } from '../utils';
import { OVERRIDE_ENTRY_CONFIG } from '../constants';
import { configuredMenuItemTransformer } from './utils';
import { cmsConfigTransformer } from './cmsConfigTransformer';
import type {
    CategoryWebLink,
    ExtendedTransformedCmsConfigItemLevels,
    TransformedCmsConfigItemLevels,
    ValueOf,
} from './types';

type Mode = ValueOf<typeof MODES>;

export interface MenuTransformerProps {
    useCmsConfig: boolean;
    config?: TransformedCmsConfigItemLevels;
    cmsConfig?: CategoryWebLink;
    locale: string;
    theme: string;
    shouldPreRender: boolean;
    mode: Mode;
    rollouts: Record<string, boolean | undefined>;
}

export interface TransformedMenuProps {
    useCmsConfig?: boolean;
    config: ExtendedTransformedCmsConfigItemLevels;
    locale?: string;
    theme?: string;
    shouldPreRender?: boolean;
    mode?: Mode;
    rollouts?: Record<string, boolean | undefined>;
}

export const cmsConfigurationTransformer = (props: MenuTransformerProps) => {
    const { useCmsConfig, config, cmsConfig, locale, theme, shouldPreRender, mode, rollouts } = props;

    return {
        useCmsConfig,
        config: configTransformer(cmsConfig ? cmsConfigTransformer(cmsConfig) : config ?? {}, locale, mode),
        locale,
        theme,
        shouldPreRender,
        mode,
        rollouts,
    };
};

export const configTransformer = (
    config: TransformedCmsConfigItemLevels,
    locale?: string,
    mode?: Mode
): ExtendedTransformedCmsConfigItemLevels =>
    Object.keys(config).reduce<ExtendedTransformedCmsConfigItemLevels>(
        (levels, level) => ({
            ...levels,
            [level]: Object.keys(config[level]).reduce<ValueOf<ExtendedTransformedCmsConfigItemLevels>>(
                (res, itemId) => ({
                    ...res,
                    [itemId]: config[level][itemId].map((item) => {
                        if (Object.prototype.hasOwnProperty.call(OVERRIDE_ENTRY_CONFIG, itemId)) {
                            merge(item, OVERRIDE_ENTRY_CONFIG[itemId]);
                        }
                        return configuredMenuItemTransformer(item, locale, mode);
                    }),
                }),
                {}
            ),
        }),
        {}
    );
